import React, { Component } from "react";
import {isObservable, toJS} from "mobx";
import {
  Form,
  Spin,
  Button,
  Input,
  Tag,
  Icon,
  Divider,
  Avatar,
  Select,
  DatePicker,
  Switch,
  Rate,
  notification,
  Collapse
} from "antd";
import moment from 'moment';
import update from 'immutability-helper';

const Panel = Collapse.Panel;
const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

class userForm extends Component {
  constructor(props) {
    super(props);
    console.log("props", this.props);
    this.state = Object.assign(this.props.user || {}, {inputVisible: false, inputValue: null});
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // Start zipcode tag cloud helper funcs
  handleClose = (removedTag) => {
    // const zipCode = (this.state.zipCode instanceof Array ? this.state.zipCode : [this.state.zipCode]).filter(tag => tag !== removedTag);
    console.log("RM", removedTag);
    // const zipCode = Object.assign({}, this.state.zipCode);
    delete this.state.zipCode[removedTag];
    // console.log(zipCode);
    this.setState(this.state);
  }
  componentWillReceiveProps(nextProps){
    // console.log('componentWillReceiveProps', nextProps);
    if(nextProps.user){
      // console.log('nextProps', nextProps);
      this.setState(Object.assign(nextProps.user || {}, {inputVisible: false, inputValue: null}));
      // console.log('statttte',this.state);
    }
  }
  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  }

  handleInputChange = (e) => {
    if(e.target.value.length <6) { // if zipcode i
      this.setState({ inputValue: e.target.value });
    }
  }

  handleInputConfirm = () => {
    const state = this.state;
    const inputValue = state.inputValue;
    // let zipCode = state.zipCode instanceof Array ? state.zipCode : [state.zipCode];
    let zipCode = this.state.zipCode;
    // if (inputValue && zipCode.indexOf(inputValue) === -1) {
    //   zipCode = [...zipCode, inputValue];
    //   zipCode =
    // }
    if(inputValue && ( !zipCode || [inputValue] != true )){
      zipCode = {...zipCode, [inputValue]: true};
    }
    // console.log(zipCode);
    this.setState({
      zipCode,
      inputVisible: false,
      inputValue: '',
    });
  }

  saveInputRef = input => this.input = input
  // End zipcode tag cloud helper funcs
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({loading: true});
    var clone = Object.assign(this.state)
    delete clone.inputVisible;
    delete clone.inputValue;
    delete clone.loading;
    delete clone.disabled;
    if(isObservable(clone)){
      console.log('IS OBS !!');
      clone = toJS(clone);
    }
    console.log('CLONE is:', clone);
    console.log('CLONE DATE', );
    if(/\d/.test(clone.firstname) || /\d/.test(clone.lastname)) {
      notification.error({
        message: "Impossible d'effectuer l'opération",
        description: "Le nom et prénom ne peux pas contenir de numéro(s)"
      })
      this.setState({loading: false});
      return false;
    }
    if(/\D/.test(clone.phonenumber) || (clone.role === 'patient' && /\D/.test(clone.emergencyPhonenumber))) {
      notification.error({
        message: "Impossible d'effectuer l'opération",
        description: "Le numéro de téléphone ou le numéro de contact d'urgence ne peux contenir que des numéros"
      })
      this.setState({loading: false});
      return false;
    }
    if(clone.phonenumber.length > 10 || (clone.emergencyPhonenumber ? clone.emergencyPhonenumber.length > 10 : false)) {
      notification.error({
        message: "Impossible d'effectuer l'opération",
        description: "Le numéro de téléphone ou le numéro de contact d'urgence est trop long"
      })
      this.setState({loading: false});
      return false;
    }
    var emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if(!emailRegEx.test(clone.email)) {
      notification.error({
        message: "Impossible d'effectuer l'opération",
        description: "L'adresse email est mal formatée"
      })
      this.setState({loading: false});
      return false;
    }
    if(clone.role === 'patient' && clone.zipCode.length > 5) {
      notification.error({
        message: "Impossible d'effectuer l'opération",
        description: "Le code postal est trop long"
      })
      this.setState({loading: false});
      return false;
    }
    if(!(clone.birthday instanceof Date)) {
      notification.error({
        message: "Impossible d'effectuer l'opération",
        description: "Date de naissance mal formatée"
      })
      this.setState({loading: false});
      return false;
    }
    if(!(clone.role === 'patient' || clone.role === 'nurse' || clone.role === 'admin')) {
      notification.error({
        message: "Impossible d'effectuer l'opération",
        description: "Role Manquant"
      })
      this.setState({loading: false});
      return false;
    }
    try {
      await this.props.submit(clone);
    } catch(e) {
      console.log('Error', e);
      notification.error({
        message: "Impossible d'effectuer l'opération",
        description: e.message
      })
      this.setState({loading: false});
      return false;
    }
    this.setState({loading: false});
    notification.success({
      message: "Opération réussie"
    })
    this.props.closeModal ? this.props.closeModal() : null;
    this.setState(this.props.user ? {...this.props.user} : {...Object.keys(this.state).forEach(v => this.state[v] = null)} )
  }
  render() {
    // console.log('this.props.user', this.props.user)
    const days = {
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche'
    };
    const formItemLayout = {

    };
    const zip = [];
    Object.keys(this.state.zipCode ? this.state.zipCode : {}).forEach((tag) => {
      zip.push(tag);
      // console.log('ZIP', zip);
      // console.log('ZIPCODE', this.state.zipCode);
    });
    const {inputVisible, inputValue } = this.state;

    const nurseFields = ([
      <FormItem {...formItemLayout} key={'français'} label="Parlez-vous correctement le français?">
        <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} defaultChecked={!!this.state.lang} onChange={value => this.setState({lang: value})} />
      </FormItem>,
      <FormItem {...formItemLayout} key={'visa'} label="Etes vous légalement autorisé(e) à travailler en France/UE?">
        <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} defaultChecked={!!this.state.visa} onChange={value => this.setState({visa: value})} />
      </FormItem>,
      <FormItem {...formItemLayout} key={'historique'} label="Depuis combien de temps êtes-vous intervenant(e) à domicile en France ?">
        <Input
          value={this.state.history || ''}
          disabled={!!this.props.disabled}
          onChange={event => this.setState({history: event.target.value })}
          />
      </FormItem>,
      <FormItem {...formItemLayout} key={'rev'} label="Combien d'heures d'intervention à domicile souhaitez-vous effectuer chaque semaine à travers Hoomiz?">
        <Input
          value={this.state.hoursAweek || ''}
          disabled={!!this.props.disabled}
          onChange={event => this.setState({hoursAweek: event.target.value })}
          />
      </FormItem>,
      <FormItem {...formItemLayout} key={'criminal'} label="Votre casier judiciaire contient-il des condamnations pénales ?">
        <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} defaultChecked={!!this.state.criminal} onChange={value => this.setState({criminal: value})} />
      </FormItem>,
      <FormItem {...formItemLayout} key={'diploma'} label="De quel(s) diplôme(s) ou formation(s) certifiante(s) êtes-vous titulaire?">
        <Input
          value={this.state.diplomas || ''}
          disabled={!!this.props.disabled}
          onChange={event => this.setState({diplomas: event.target.value })}
          />
      </FormItem>,
      <FormItem {...formItemLayout} key={'moto'} label="Devise">
        <Input
          value={this.state.moto || ''}
          disabled={!!this.props.disabled}
          onChange={event => this.setState({moto: event.target.value })}
          />
      </FormItem>,
      // <FormItem {...formItemLayout} key={'cert'} label="Disposez-vous d'un agrément pour effectuer les services d'aide à domicile pour les personnes âgées ?">
      //   <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} defaultChecked={!!this.state.nurseAgreement} onChange={value => this.setState({nurseAgreement: value})} />
      // </FormItem>,
      // <FormItem {...formItemLayout} key={'status'} label="Etes-vous sous le régime auto-entrepreneur?">
      //   <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} defaultChecked={!!this.state.autoentrepreneur} onChange={value => this.setState({autoentrepreneur: value})} />
      // </FormItem>,
      <Collapse key={'schedule'}>
        {Object.keys(days).map((day, i) => (
          <Panel key={i} header={days[day]}>

            <span style={{margin: 10}}>
              <a>Matin (8h->12h): </a>
            <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} defaultChecked={this.state.scheduleAvailability ? (this.state.scheduleAvailability[day]? (!!this.state.scheduleAvailability[day].morning): false): false} onChange={ value => this.setState({scheduleAvailability: {...this.state.scheduleAvailability, [day]: {...(this.state.scheduleAvailability == undefined ? {} : this.state.scheduleAvailability[day]), morning: value}}})}/>
            </span>
            <span style={{margin: 10}}>
              <a>Après-midi (12h->18h): </a>
            <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} defaultChecked={this.state.scheduleAvailability ? (this.state.scheduleAvailability[day]? (!!this.state.scheduleAvailability[day].afternoon): false): false} onChange={ value => this.setState({scheduleAvailability: {...this.state.scheduleAvailability, [day]: {...(this.state.scheduleAvailability == undefined ? {} : this.state.scheduleAvailability[day]), afternoon: value}}})}/>
            </span>
            <span style={{margin: 10}}>
              <a>Soir (18h->00h): </a>
            <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} defaultChecked={this.state.scheduleAvailability ? (this.state.scheduleAvailability[day]? (!!this.state.scheduleAvailability[day].night): false): false} onChange={ value => this.setState({scheduleAvailability: {...this.state.scheduleAvailability, [day]: {...(this.state.scheduleAvailability == undefined ? {} : this.state.scheduleAvailability[day]), night: value}}} )}/>
            </span>
            <span style={{margin: 10}}>
              <a>Nuit (00h->8h): </a>
            <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} defaultChecked={this.state.scheduleAvailability ? (this.state.scheduleAvailability[day]? (!!this.state.scheduleAvailability[day].dawn): false): false} onChange={ value => this.setState({scheduleAvailability: {...this.state.scheduleAvailability, [day]: {...(this.state.scheduleAvailability == undefined ? {} : this.state.scheduleAvailability[day]), dawn: value}}} ) }/>
            </span>
          </Panel>
        ))}
      </Collapse>,
      <FormItem {...formItemLayout} key={'validé'} label="Intervenant Validé?">
        <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} defaultChecked={!!this.state.isNurseValidated} onChange={value => this.setState({isNurseValidated: value})} />
      </FormItem>,
      <br key={'break'}/>
    ]);
    return (
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        <Form layout={!!this.props.disabled ? "horizontal" : "vertical"} onSubmit={this.handleSubmit} style={{ maxWidth: 800 }} className={!!this.props.disabled? 'readOnlyForm': null}>
          <FormItem {...formItemLayout} label="Rôle">
            <Select disabled={!!this.props.disabled} defaultValue={this.state.role} onChange={value => {this.setState({zipCode: null}); this.setState({role: value })} }>
              <Option value="admin">Admin</Option>
              <Option value="patient">Client</Option>
              <Option value="nurse">Intervenant</Option>
            </Select>
          </FormItem>

          {this.state.role === "patient" && this.state.accountManager ?
            <div>
              <Divider orientation="left">Informations du client</Divider>
                <FormItem {...formItemLayout} label="Civilité">
                  <Select disabled={!!this.props.disabled} defaultValue={toJS(this.state.accountManager.civ)} onChange={value => this.setState(update(this.state, {accountManager: { $merge: {civ: value } }} ))}>
                    <Option value="Monsieur">Monsieur</Option>
                    <Option value="Madame">Madame</Option>
                  </Select>
                </FormItem>
                <FormItem {...formItemLayout} label="Prénom">
                  <Input
                    value={this.state.accountManager.firstname || ''}
                    disabled={!this.props.isCreate}
                    onChange={event => this.setState(update(this.state, {accountManager: { $merge: {firstname: event.target.value } }}) )}
                  />
                </FormItem>

                <FormItem {...formItemLayout} label="Nom">
                  <Input
                    value={this.state.accountManager.lastname || ''}
                    disabled={!this.props.isCreate}
                    onChange={event => this.setState(update(this.state, {accountManager: { $merge: {lastname: event.target.value } }} ) )}
                  />
                </FormItem>
                <FormItem {...formItemLayout} label="Lien de parenté avec le proche">
                  <Input
                    value={this.state.accountManager.relation || ''}
                    disabled={!!this.props.disabled}
                    onChange={event => this.setState(update(this.state, {accountManager: { $merge: {relation: event.target.value } }} ) )}
                  />
                </FormItem>
                <FormItem {...formItemLayout} label="Email">
                  <Input
                    value={this.state.email || ''}
                    disabled={!this.props.isCreate}
                    onChange={event => this.setState({email: event.target.value})}
                    />
                </FormItem>
                <FormItem {...formItemLayout} label="Téléphone">
                  <Input
                    value={this.state.phonenumber || ''}
                    disabled={!!this.props.disabled}
                    onChange={event => this.setState(update(this.state, {accountManager: { $merge: {phonenumber: event.target.value } }} ))}
                  />
                </FormItem>


              <Divider orientation="left">Informations du bénéficiaire</Divider>
          </div>
          : null }
          <FormItem {...formItemLayout} label="Email">
            <Input
              value={this.state.email || ''}
              disabled={!this.props.isCreate}
              onChange={event => this.setState({email: event.target.value })}
              />
          </FormItem>
          {this.props.isCreate ? <FormItem {...formItemLayout} label="Mot de passe">
            <Input
              value={this.state.password || ''}
              disabled={!!this.props.disabled}
              type="password"
              onChange={event => this.setState({password: event.target.value })}
              />
          </FormItem> : null}
          <FormItem {...formItemLayout} label="Civilité">
            <Select disabled={!!this.props.disabled} defaultValue={this.state.civ} onChange={value => this.setState({civ: value })}>
              <Option value="Monsieur">Monsieur</Option>
              <Option value="Madame">Madame</Option>
            </Select>
          </FormItem>
          <FormItem {...formItemLayout} label="Prénom">
            <Input
              value={this.state.firstname || ''}
              disabled={!this.props.isCreate}
              onChange={event => this.setState({firstname: event.target.value })}
            />
          </FormItem>

          <FormItem {...formItemLayout} label="Nom">
            <Input
              value={this.state.lastname || ''}
              disabled={!this.props.isCreate}
              onChange={event => this.setState({lastname: event.target.value })}
            />
          </FormItem>

          <FormItem {...formItemLayout} label="Date de Naissance">
            <DatePicker disabled={!!this.props.disabled} format="DD MMMM YYYY" defaultValue={moment(this.state.birthday) || null} onChange={value => this.setState({birthday: value ? value.toDate() : null})} />
          </FormItem>

          <FormItem {...formItemLayout} label="Adresse Email Validée">
            <Switch disabled={!!this.props.disabled} checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} defaultChecked={!!this.state.isEmailVerified} onChange={value => this.setState({isEmailVerified: value})} />
          </FormItem>

          <FormItem {...formItemLayout} label="Ville">
            <Input
              value={this.state.city || ''}
              disabled={!!this.props.disabled}
              onChange={event => this.setState({city: event.target.value })}
            />
          </FormItem>

          <FormItem {...formItemLayout} label="Adresse">
            <Input
              value={this.state.address || ''}
              disabled={!!this.props.disabled}
              onChange={event => this.setState({address: event.target.value })}
            />
          </FormItem>
          <FormItem {...formItemLayout} label="Complément d'adresse">
            <TextArea rows={4}
              value={this.state.extra || ''}
              disabled={!!this.props.disabled}
              onChange={event => this.setState({extra: event.target.value })}
            />
          </FormItem>

          <FormItem {...formItemLayout} label="Téléphone">
            <Input
              value={this.state.phonenumber || ''}
              disabled={!!this.props.disabled}
              onChange={event => this.setState({phonenumber: event.target.value })}
            />
          </FormItem>

          {this.state.role === "nurse" ? <FormItem {...formItemLayout} label="Code Postaux:">
            {zip.map((tag, index) => {
              console.log('TAG', tag);
              if(this.state.zipCode[tag])
                return <Tag key={index} closable={!this.props.disabled} afterClose={() => this.handleClose(tag)}>{tag}</Tag>;
            })
          }
            {inputVisible && !this.props.disabled && (
              <Input
                ref={this.saveInputRef}
                type="text"
                size="small"
                style={{ width: 78 }}
                value={inputValue}
                onChange={this.handleInputChange}
                onBlur={this.handleInputConfirm}
                onPressEnter={this.handleInputConfirm}
              />
            )}
            {!inputVisible && !this.props.disabled && (
              <Tag
                onClick={this.showInput}
                style={{ background: '#fff', borderStyle: 'dashed' }}
              >
                <Icon type="plus" /> Ajouter
              </Tag>
            )}
          </FormItem> : <FormItem {...formItemLayout} label="Code Postal:">
          <Input
            value={this.state.zipCode}
            disabled={!!this.props.disabled}
            onChange={event => this.setState({zipCode: event.target.value })}
            />
        </FormItem>}

        {this.state.role === "patient" ?  <FormItem {...formItemLayout} label="Numéro à contacter en cas d’urgence">
          <Input
            value={this.state.emergencyPhonenumber || ''}
            disabled={!!this.props.disabled}
            onChange={event => this.setState({emergencyPhonenumber: event.target.value })}
          />
        </FormItem> : null }
        {this.state.role === "patient" ?
          <FormItem {...formItemLayout} label="Situation familiale">
            <Select disabled={!!this.props.disabled} defaultValue={this.state.familySituation} onChange={value => {this.setState({familySituation: value })} }>
              <Option value="Célibataire">Célibataire</Option>
              <Option value="En couple">En couple</Option>
              <Option value="Veuf(ve)">Veuf(ve)</Option>
              <Option value="Divorcé(e)">Divorcé(e)</Option>
            </Select>
          </FormItem>
          : null
        }
        {this.state.role === "nurse" ? nurseFields : null
        }
        <div key={'mango info'}>
          <Divider orientation="left">Infos MANGOPAY</Divider>
            <FormItem {...formItemLayout} label="Identifiant:">
              <Input
                value={this.state.mangoId}
                disabled={true}
                />
            </FormItem>
            <FormItem {...formItemLayout} label="Portefeuille:">
              <Input
                value={this.state.walletId}
                disabled={true}
                />
            </FormItem>
            <FormItem {...formItemLayout} label={this.state.role === "nurse" ? "Compte bancaire: " : "Carte de paiement:"}>
              <Input
                value={this.state.role === "nurse" ? this.state.bankId : this.state.cardId}
                disabled={true}
                />
            </FormItem>
        </div>


          {!!this.props.disabled ? null :
          <FormItem style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
            <a onClick={() => {this.props.closeModal ? this.props.closeModal() : null; this.props.switchFunc ? this.props.switchFunc() : null; }} style={{margin: 25}}><u>Annuler</u></a>
            <Button type="primary" size='large' htmlType="submit" loading={this.state.loading}>Enregistrer</Button>
          </FormItem> }
        </Form>

      </div>
    );
  }
}
const UserForm = Form.create()(userForm);
export default UserForm;



// WEBPACK FOOTER //
// ./src/UserForm.js